module.exports = __webpack_public_path__ + "img/SketchPngd7af1112217ea235eaaa05ae35b1dd0dc07d9c2d3be531c7829a5ef93a1b8801.013008f3.png";